// extracted by mini-css-extract-plugin
export default {"eventsCardDiv":"EventsCards_eventsCardDiv__h9bRz","textInfo":"EventsCards_textInfo__jJF68","detail":"EventsCards_detail__Rae3n","eventsImage":"EventsCards_eventsImage__cd634"};